import { useState, useEffect } from 'react';

export interface DeviceType {
  isAndroid: boolean;
  isIOS: boolean;
  isMobile: boolean;
}

// will return null on the server and during first render (before hydration).
// and once the component mounts on the client, it will return the real device type
export default function useDeviceType(): DeviceType | null {
  const [device, setDevice] = useState<DeviceType | null>(null);

  useEffect(() => {
    const ua = navigator.userAgent;
    setDevice({
      isAndroid: /android/i.test(ua),
      isIOS: /iphone|ipad|ipod/i.test(ua),
      isMobile: /android|iphone|ipad|ipod|mobile/i.test(ua),
    });
  }, []);

  return device;
}
